import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';

const IcoRepeat40 = ({ 'aria-label': ariaLabel, className, color }: IconProps) => {
  const iconColor = getIconColor(color);
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
      className={className}
      role="img"
      data-colored={false}
    >
      <g>
        <path
          d="M28.75 35L33.1608 30.5893C33.4862 30.2638 33.4862 29.7362 33.1608 29.4107L28.75 25M11.25 5L6.83929 9.41075C6.51386 9.73618 6.51386 10.2638 6.83929 10.5892L11.25 15M8.33336 10H31.6667C32.5872 10 33.3333 10.7462 33.3333 11.6667V18.3333M6.66669 21.6667V28.3333C6.66669 29.2538 7.41289 30 8.33336 30H31.6667"
          stroke={iconColor}
          strokeWidth={3.333}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs />
    </svg>
  );
};
export default IcoRepeat40;
